<template lang="jade">
  style(v-html="errorStyles")
  div.animated(v-if="!reload" transition="fade")
    app-form(":uid"="uid")
</template>

<script>
import { forms, workflow } from 'src/vuex/getters'
import { addForm,
         addNotification,
         setWorkflow,
         clearAllNotifications } from 'src/vuex/actions'
import _ from 'lodash'

export default {
  props: {
    content: {
      type: Object,
      required: true
    },
    uid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      actions: [],
      reload: false,
      errorStyles: '',
      errorMap: {
        'This sort code and account number are not valid': ['BANK.SORT.CODE', 'BANK.ACCOUNT.NUMBER'],
        'Sort code is not on file': ['BANK.SORT.CODE', 'BANK.ACCOUNT.NUMBER']
      },
      history: {
        back: true
      }
    }
  },
  vuex: {
    getters: {
      forms,
      workflow
    },
    actions: {
      addForm,
      addNotification,
      setWorkflow,
      clearAllNotifications
    }
  },
  components: {
    'app-form': require('src/components/forms/standard')
  },
  watch: {
    'content': 'addFragment'
  },
  methods: {
    compile (data) {
      let formatted = this.format(data.content)
      let targets = this.findByType('type_editAddress', formatted)
      let filtered = this.removeByType('type_editAddress', formatted)
      return Object.assign({}, data, { fields: filtered,
                                       targets: targets })
    },

    format (data) {
      return _.map(data, x => {
        x = (x.type !== 'type_contentGroup') ? x : _.set(x, 'type', x.format === undefined || x.format === 'default' ? x.class : x.format)
        if (x.type === 'type_button' && x.actions.length > 0) {
          this.actions.push(_.head(x.actions))
        }
        return _.isNil(x.content) ? x : _.set(x, 'content', this.format(x.content))
      })
    },

    findByType (type, coll) {
      return _.reduce(coll, (acc, xs) => {
        if (xs.type === type) acc.push(xs)
        return _.isNil(xs.content) ? acc : _.concat(acc, this.findByType(type, xs.content))
      }, [])
    },

    removeByType (type, coll) {
      return _.reduce(coll, (acc, xs) => {
        return xs.type === type ? acc
                                : _.concat(acc, _.isNil(xs.content) ? xs : _.set(xs, 'content', this.removeByType(type, xs.content)))
      }, [])
    },

    errors (coll) {
      _.forEach(coll, xs => {
        this.notice('error', xs)
        if (_.has(this.errorMap, xs)) {
          let styles = _.map(this.errorMap[xs], x => `input[name="${x}"] { border-color: #db472e !important } `).join('')
          this.$set('errorStyles', styles)
        }
      })
    },

    notice (type, msg) {
      this.addNotification({type: type,
                            msg: [msg],
                            id: _.uniqueId(),
                            timeout: 3000,
                            onComplete: 'remove',
                            show: true})
    },

    addFragment () {
      this.reload = true
      let compiled = this.compile(this.content)
      let form = _.head(compiled.content)
      this.$set('history.back', _.includes(this.actions, 'back'))
      this.$set('actions', [])
      this.$set('errorStyles', '')
      this.errors(form.errors)
      this.setHistory(this.uid)

      let workflow = _.find(this.workflow, ['uid', this.uid])
      this.addForm({
        uid: this.uid,
        workflow: workflow.fid,
        form: Object.assign({}, compiled, {meta: workflow}),
        siteid: workflow.sid
      })
      setTimeout(() => { this.reload = false }, 500)
    },

    setHistory (id) {
      let state = {
        uid: id,
        ts: Date.now(),
        count: this.forms.length
      }
      let hash = id.split('_')[0]
      if (this.forms.length === 0) {
        history.replaceState(state, null, `#${hash}`)
      } else {
        history.pushState(state, null, `#${hash}`)
      }
    }
  },
  created () {
    this.addFragment()
  },
  ready () {
    window.onpopstate = e => {
      if (!this.history.back && e.state.count > 0) {
        location.reload()
        return false
      }
      this.reload = true
      let uid = e.state.uid
      this.$set('uid', uid)
      this.clearAllNotifications()
      setTimeout(() => {
        this.$set('reload', false)
      }, 800)
    }
  }
}
</script>



// WEBPACK FOOTER //
// sheet.vue?662a46b0